<template>
  <div>
    <div v-if="this.created">
      <div class="login-wrap">
        <div class="heading-primary">Welcome!</div>
        <p>Your account has been created. Click the link below to access.</p>
        <router-link to="/home" class="btn">
          Go to Dashboard
        </router-link>
      </div>
    </div>
    <div v-if="!this.created">
      <div class="setup-instructions">
        <div class="heading-tertiary">Create login for Weekly Coach Payment Portal:</div>
        <ol>
          <li>Enter email used to purchase weekly coach</li>
          <li>Create a password</li>
          <li>Click the “Setup” button</li>
          <li>You’re in!</li>
        </ol>
      </div>
      <div class="login-wrap" style="margin-top: 0;">
        <form @submit.prevent="userSetup">
          <div class="email">
            <input type="email" v-model="setupemail" placeholder="email">
          </div>
          <div class="password">
            <input type="password" v-model="setuppassword" placeholder="password" autocomplete="new-password">
          </div>
          <div class="password">
            <input type="password" v-model="verifypassword" placeholder="re-enter password" autocomplete="new-password">
          </div>
          <button type="submit">Setup</button>
        </form>
        <div class="error" v-if="error">{{this.error}}</div>
      </div>
      <div class="login-wrap">
      <p>Having trouble creating an account?<br>Email <a href="mailto:marketingplus@roadsidemultimedia.com">marketingplus@roadsidemultimedia.com</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  metaInfo: {
    title: 'DIY Marketing Resources APP | Account Setup'
  },
  data() {
    return {
      setupemail: '',
      setuppassword: '',
      verifypassword: '',
      error: '',
      user: null,
      showpw: '',
      created: ''
    }
  },
  created() {
    this.setupemail = this.$route.query.email;
  },
  methods: {
    userSetup() {
      if(this.setuppassword == this.verifypassword) {
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.setupemail, this.setuppassword)
          .then(data => {
            this.created = true
          })
          .catch(err => {
            this.error = err.message;
          });
      } else {
        this.error = "Password do not match"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.setup-instructions {
  text-align: center;
  display: block;
  margin: 80px auto 0;
  max-width: 400px;
  ol {
    text-align: left;
  }
}
</style>